import { createPanel } from '@atlassian/entry-point-panel';

export const ConfigureStatusPanel = createPanel();
